module.exports = __webpack_public_path__ + "dist/media/ec_comp_buttons.1a557eb5.svg";